// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","4213":"367f7a408e6f5cea","6676":"91d4415a003aafed","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};